/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PersonIdAttachments202,
  PostApiV1PersonIdAttachments400,
  PostApiV1PersonIdAttachments401,
  PostApiV1PersonIdAttachments404,
  PostApiV1PersonIdAttachments500,
  PostApiV1PersonIdAttachmentsMutationRequest,
  PostApiV1PersonIdAttachmentsMutationResponse,
  PostApiV1PersonIdAttachmentsPathParams,
} from "../../types/personDocumentsController/PostApiV1PersonIdAttachments.ts";

export const postApiV1PersonIdAttachmentsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1PersonIdAttachmentsPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1PersonIdAttachments202Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAttachments202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PersonIdAttachments400Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAttachments400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PersonIdAttachments401Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAttachments401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1PersonIdAttachments404Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAttachments404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PersonIdAttachments500Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAttachments500>;

export const postApiV1PersonIdAttachmentsMutationRequestSchema = z.object({
  File: z.optional(z.instanceof(File)),
  ClassStudentId: z.optional(z.number().int()),
  EnrollmentDocumentId: z.optional(z.number().int()),
}) as unknown as ToZod<PostApiV1PersonIdAttachmentsMutationRequest>;

export const postApiV1PersonIdAttachmentsMutationResponseSchema = z.lazy(
  () => postApiV1PersonIdAttachments202Schema,
) as unknown as ToZod<PostApiV1PersonIdAttachmentsMutationResponse>;
